'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../_commonjsHelpers-6ecf82ef.js');
require('../extends-733dd656.js');
require('react');
require('../taggedTemplateLiteral-f923b98d.js');
require('styled-components');
require('../xstyled-styled-components.es-6e2bde7d.js');
require('../extends-5ede7877.js');
require('../unsupportedIterableToArray-f175acfa.js');
require('../breakpoints-ee0a4ae5.js');
require('../utils/env/isTestEnv/isTestEnv.js');
require('../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../utils/env/isProdEnv/isProdEnv.js');
require('../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
var styles_theme = require('../theme-80c5a73f.js');
require('../polished.esm-8ddeb0a5.js');
require('../colorBuilder-8c1a81a8.js');



exports.default = styles_theme.theme;
exports.gutter = styles_theme.gutter;
exports.margin = styles_theme.margin;
exports.typography = styles_theme.typography;
exports.zIndexes = styles_theme.zIndexes;
//# sourceMappingURL=theme.js.map
